<template>
  <div class="user_list_page">
    <pageTitle v-bind="{ ...pT }" />
    <business-group :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }" ref="businessGroup">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-date-picker
            :initialValue="moment(new Date())"
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="startDateDisabledDate"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            v-decorator="['startDateTime']"
            style="vertical-align: middle; width: 150px; margin-right: 10px"
          />
        </a-form-item>
        <a-form-item>
          <a-date-picker
            :initialValue="moment(new Date())"
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="startDateDisabledDate"
            :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
            v-decorator="['endDateTime']"
            style="vertical-align: middle; width: 150px; margin-right: 10px"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="请输入TraceId"
            v-decorator="['traceId']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="请输入设备id"
            v-decorator="['deviceId']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
      </template>
      <template slot="createTime" slot-scope="record">
        {{ dataFormatStr(record.createTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>
      <template slot="updateTime" slot-scope="record">
        {{ dataFormatStr(record.updateTime, "YYYY-MM-DD HH:mm:ss") }}
      </template>
      <template slot="msgType" slot-scope="record">
        {{ record.msgType == 1 ? "下发设备" : "设备上报" }}
      </template>
    </business-group>
  </div>
</template>

<script>
import moment from "moment";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import { formatToStr } from "@/utils/dateUtils";

export default {
  created() {

  },
  components: {
    pageTitle,
    businessGroup,
    formTime
  },
  data() {
    return {
      pT: {
        pageTitle: "注册设备"
        // headerTitle: '绑定时间',
        // text: '(单次操作不超过1年)',
      },
      tableConfig: {
        url: "bluetoothlight/web/router/neewerhome/manage/mqtt/info/get",
        columns: [
          {
            title: "traceId",
            dataIndex: "traceId",
            key: "traceId",
            align: "left"
          },
          {
            title: "主题",
            dataIndex: "topic",
            key: "topic",
            align: "center"
          },
          {
            title: "数据",
            dataIndex: "payload",
            key: "payload",
            align: "center"
          },
          {
            title: "类型",
            scopedSlots: { customRender: "msgType" },
            key: "msgType",
            align: "center"
          },
          {
            title: "errorLog",
            dataIndex: "errorLog",
            key: "errorLog",
            align: "center"
          },
          {
            title: "时间",
            key: "createTime",
            scopedSlots: { customRender: "createTime" },
            align: "center"
          }
        ],
        rowKey: "createTime"
      },
      formConfig: {
        timeShow: false,
        formShow: true
      },
      visible: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 15 }
    };
  },
  methods: {
    moment,
    startDateDisabledDate(current) {
      return current && current > moment();
    },
    dataFormatStr(ret, format) {
      if (!ret) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return formatToStr(ret, format);
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    }
  }
};
</script>


<style lang="less" scoped>
.user_list_page {
  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}
</style>
  